/**
 * ExecutionStatusLine — top row of the execution summary: execution id (with
 * copy) on the left, overall status and current location on the right. Pure
 * presentational.
 */
import Badge from '@cloudscape-design/components/badge';
import Box from '@cloudscape-design/components/box';
import StatusIndicator from '@cloudscape-design/components/status-indicator';
import CopyToClipboard from '@cloudscape-design/components/copy-to-clipboard';
import { ExecutionDetailView } from 'src/store/slices/executionDetail/executionDetailTypes';

interface ExecutionStatusLineProps {
  id: string;
  statusLabel: string;
  statusType: ExecutionDetailView['statusType'];
  locationBadge: string;
}

export const ExecutionStatusLine = ({ id, statusLabel, statusType, locationBadge }: ExecutionStatusLineProps) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Box variant="h1">{id}</Box>
      <CopyToClipboard
        variant="icon"
        textToCopy={id}
        copyButtonAriaLabel="Copy execution id"
        copySuccessText="Execution id copied"
        copyErrorText="Failed to copy execution id"
      />
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
      <StatusIndicator type={statusType}>{statusLabel}</StatusIndicator>
      <Badge color="grey">{locationBadge}</Badge>
    </div>
  </div>
);
